export default {
  items: [
    // {
    //   name: 'Delivery',
    //   url: '/delivery',
    //   icon: 'fa fa-truck-moving',
    //   badge: {
    //     variant: 'info'
    //   }
    // },
    {
      name: 'Vendas de hoje',
      url: '/vendas-hoje',
      icon: 'fa fa-shopping-basket',
      badge: {
        variant: 'info'
      }
    },
    {
      name: 'Vendas fechadas',
      url: '/vendas-fechadas',
      icon: 'fa fa-shopping-basket',
      badge: {
        variant: 'info'
      }
    },
    {
      name: 'Conta',
      url: '/conta',
      icon: 'fa fa-balance-scale',
      badge: {
        variant: 'info'
      }
    },
    {
      name: 'Conciliação',
      url: '/conciliacao',
      icon: 'fa fa-balance-scale',
      badge: {
        variant: 'info'
      }
    },
    // A Oferta é Sua é adicionada dinamicamente no defaultHeader.js quando necessário
    // Antecipação também é adicionada dinamicamente no defaultHeader.js
    /*     {
      name: 'Área Pix',
      url: '/conta',
      icon: 'fa fa-balance-scale',
      badge: {
        variant: 'info',
      },
    }, */
  ]
}
